var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

/**
 * 查询当前节点信息的接口
 * @constructor
 * @param {RPC}rpc - 通过rpc生成Net模块
 */
var Net =
/*#__PURE__*/
function () {
  "use strict";

  function Net(rpc) {
    _classCallCheck(this, Net);

    this._provider = rpc.getProvider();
  }

  _createClass(Net, [{
    key: "getProvider",
    value: function getProvider() {
      return this._provider;
    }
    /**
     * 获取当前节点信息
     * @returns {promise} - 当前节点的信息
     */

  }, {
    key: "getNodeInfo",
    value: function getNodeInfo() {
      return this._provider.send('get', 'getNodeInfo');
    }
  }]);

  return Net;
}();

module.exports = Net;